import { get, getTableManager } from '@/core/container/ioc'
import type FilterServiceManagerInterface from '@/services/tables/managers/filterServiceManagerInterface'
import type { UseTableBuilderSettings } from '@/composition/table/types'
import type { Endpoint } from '@/services/endpoints'
import type { Operation } from '@/services/types'

type UseFiltersSettings = Pick<UseTableBuilderSettings, 'tableModelId' | 'filterServiceManager' | 'filterFactory'> & {
  endpoint: Endpoint
}

export const useFilters = (settings: Pick<UseFiltersSettings, 'filterServiceManager'>) =>
  get<FilterServiceManagerInterface>(settings.filterServiceManager ?? 'TableFilterServiceManager')

export const createFilters = (settings: UseFiltersSettings) => {
  const manager = get<FilterServiceManagerInterface>(settings.filterServiceManager ?? 'TableFilterServiceManager')

  if (settings.filterFactory) {
    manager.setFactoryForTable(settings.tableModelId, settings.filterFactory)
  }

  return useFilters(settings)
}

export const setFilterValue = ({
  serviceId,
  name,
  value,
  operation,
  serviceKey = String(0),
  shouldReplaceState = false,
}: {
  serviceId: string
  name: string
  value: string | string[]
  operation?: Operation
  serviceKey?: string
  shouldReplaceState?: boolean
}) => {
  const table = getTableManager().getTable(serviceId)
  const filterService = table.getFilterServiceManager().getServiceForTable(serviceId, serviceKey)
  filterService.setInnerValue(name, value)
  if (operation) {
    filterService.setInnerOperation(name, operation)
  }
  filterService.applyFilterValue(name)
  table.onApplyFilter(shouldReplaceState)
}
